import jsCookie from "js-cookie";
import React from "react";
import { Redirect } from "react-router-dom";
import { Route } from "react-router-dom/cjs/react-router-dom.min";
import PrivateHeader from "../header/privateHeader";
import { AnswerProvider } from "../store/answerStore";
import { AssignedTestProvider } from "../store/assignedTestStore";
import { LaunchTestProvider } from "../store/launchTestStore";
import { RecorderProvider } from "../store/recorderStore";
import { SurveyProvider } from "../store/surveyStore";
export default function PrivateRoute({ component: Component, ...rest }) {
  const isLogin = JSON.parse(localStorage.getItem("isLogin"));

  return (
    <AssignedTestProvider>
      <LaunchTestProvider>
        <AnswerProvider>
          <SurveyProvider>
            <RecorderProvider>
              {isLogin === "1" ? (
                rest.path === "/amaze_test" ||
                rest.path === "/calibration/test" ? (
                  <Route
                    {...rest}
                    component={(props) => {
                      return <Component {...props} />;
                    }}
                  />
                ) : (
                  <PrivateHeader component={Component} {...rest} />
                )
              ) : (
                <Redirect to="/" />
              )}
            </RecorderProvider>
          </SurveyProvider>
        </AnswerProvider>
      </LaunchTestProvider>
    </AssignedTestProvider>
  );
}
